// Single source of truth for "can this costing be finalized?"
// Mirrors backend services/npd_calc.rmc_incomplete_reasons().
export function rmcIncompleteReasons(n) {
  const reasons = [];
  const gw = Number(n?.gross_weight) || 0;
  const nw = Number(n?.net_weight) || 0;
  const rate = Number(n?.rm_price_per_kg) || 0;
  if (gw <= 0) reasons.push("Gross weight is missing or zero");
  if (nw <= 0) reasons.push("Net weight is missing or zero");
  if (rate <= 0) reasons.push("RM rate (₹/kg) is missing or zero");
  if (gw > 0 && nw > gw) reasons.push("Net weight is greater than gross weight");
  return reasons;
}

export function isRmcComplete(n) {
  return rmcIncompleteReasons(n).length === 0;
}
